import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { OrAvatarComponent, OrIconComponent } from '@ui-components';
import { Router } from '@angular/router';
import { SlicePipe } from '@angular/common';
import { GetTeamsQueryResult } from '../../application/handlers';
import {
  ChannelDetailsByReferenceQueryHandler,
  ChannelDetailsPayloadModel,
  ChannelDetailsQueryParam,
  ChannelDetailsQueryResult,
  OpenChatCommandHandler
} from '@messages';
import { ShareTeamModalComponent } from '../share-team-modal/share-team-modal.component';
import { TeamInviteData } from '../../application/models';
import { AppRoutes, MODAL_TOKEN, ModalProvider, TeamsRoutes } from '@core';
import { switchMap, take } from 'rxjs';
import { ChatChannelType } from '@core-http';

@Component({
  selector: 'lib-team-card',
  templateUrl: './team-card.component.html',
  styleUrls: ['./team-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrAvatarComponent, SlicePipe, OrIconComponent],
  providers: [OpenChatCommandHandler, ChannelDetailsByReferenceQueryHandler]
})
export class TeamCardComponent {
  readonly teamDetails: InputSignal<GetTeamsQueryResult> = input.required<GetTeamsQueryResult>();
  readonly showInfoLabel: InputSignal<boolean> = input.required<boolean>();
  readonly showShareIcon: InputSignal<boolean> = input.required<boolean>();

  private readonly router: Router = inject(Router);
  private readonly openChatCommandHandler: OpenChatCommandHandler = inject(OpenChatCommandHandler);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly channelDetailsByReferenceQueryHandler: ChannelDetailsByReferenceQueryHandler = inject(
    ChannelDetailsByReferenceQueryHandler
  );

  readonly hostInfoText: string = 'Osoby z Twojej grupki będą automatycznie zapraszane do Twojej gierki.';
  readonly memberInfoText: string =
    'Dzięki grupce jesteś automatycznie zapraszany do gierki, którą stworzy organizator.';

  goToDetails(): void {
    this.router.navigateByUrl(`${AppRoutes.TEAMS}/${this.teamDetails().teamId}/${TeamsRoutes.TEAM_DETAILS}`);
  }

  goToChat(event: Event): void {
    event.stopImmediatePropagation();

    const payload: ChannelDetailsPayloadModel = {
      param: ChannelDetailsQueryParam.TEAM,
      teamId: this.teamDetails().teamId
    };

    this.channelDetailsByReferenceQueryHandler
      .details(payload)
      .pipe(
        take(1),
        switchMap((details: ChannelDetailsQueryResult) =>
          this.openChatCommandHandler.open(details.channelExternalId, ChatChannelType.team)
        )
      )
      .subscribe();
  }

  goToAutoApprove(event: Event): void {
    event.stopImmediatePropagation();

    this.router.navigateByUrl(`${AppRoutes.TEAMS}/${this.teamDetails().teamId}/${TeamsRoutes.AUTO_APPROVE}`);
  }

  share(event: Event): void {
    event.stopImmediatePropagation();

    const payload: TeamInviteData = {
      teamId: this.teamDetails().teamId,
      token: this.teamDetails().invitationToken
    };

    this.modalProvider.showModal$({
      component: ShareTeamModalComponent,
      componentProps: { teamData: payload },
      cssClass: 'modal-auto',
      initialBreakpoint: 1,
      breakpoints: [0, 1]
    });
  }
}
